import axios from 'axios';

const URL = process.env.REACT_APP_BACKEND_URL;

// Función para obtener los headers comunes
export const getCommonHeaders = () => {
  return {
    'Content-Type': 'application/json',
    'Ocp-Apim-Subscription-Key': process.env.REACT_APP_OPC,
    'X-Azure-APGW': process.env.REACT_APP_APGW
  };
};

// Función genérica para llamar cualquier endpoint
export const callApi = async (endpoint, method = 'post', data = {}, customHeaders = {}) => {
  
  //Valida Header 
  const headers = { 
     'Content-Type': 'application/json',
      ...getCommonHeaders(), 
      ...customHeaders
     };

  try {
      const config = {
      method,
      url: `${URL}${endpoint}`,
      headers,
    };
    // Si es GET, los datos van como params
      if (method.toLowerCase() === 'get') {
        config.params = data;
      } else {
        config.data = data;
      }
      const response = await axios(config);
      return response.data;
   }catch (error) {
    console.error(`Error al llamar ${endpoint}:`, error.response?.data || error.message);
    throw error;
  }
};  

//  Funciones específicas para tus endpoints:
// POST: Crear Asesor
export const crearAsesor = (data) => { return callApi('/land/api/v1/Asesores/Crear', 'post', data); };

// GET: Seleccionar Canal
export const seleccionarCanal = (params) => { return callApi('/land/api/v1/Asesores/SeleccionarCanal', 'get', params); };

// POST: Crear Cliente
export const crearCliente = (data) => { return callApi('/land/api/v1/Clientes/Crear', 'post', data); };
// POST: Envio SMS
export const EnviarSms = (data) => { return callApi('/land/api/v1/SMS/EnviarSms', 'post', data); };
//POST: Envio Token
export const EnviarSmsToken = (data) => { return callApi('/land/api/v1/SMS/EnviarSmsToken', 'post', data); };
//POST: VerificarToken
export const VerificarToken = (data) => { return callApi('/land/api/v1/SMS/VerificarToken', 'post', data); };
